'use client';
import { AllCameras } from './AllCameras';
import { CameraViewer } from './CameraViewer';
import { TableViewerLayout } from '@components/TableViewerLayout/TableViewerLayout';
import '../page.css';
import PropTypes from 'prop-types';

const CamerasPage = ({ userIsAdmin }) => {
  return (
    <TableViewerLayout
      tableTitle='All Cameras'
      viewerTitle='Camera Viewer'
      tableSlot={<AllCameras userIsAdmin={userIsAdmin} />}
      viewerSlot={<CameraViewer userIsAdmin={userIsAdmin} />}
    />
  );
};

CamerasPage.propTypes = {
  userIsAdmin: PropTypes.bool.isRequired,
};

export default CamerasPage;
